module.exports = __webpack_public_path__ + "static/media/211CS246.2fad7d4b.JPG";